/**
 * Mobile navigation actions
 *
 * @since   1.7.0
 * @package blujay
 */
(function($) {
	$(document).ready(function() {

		// things
		var $body            = $( 'body' );
		var $header          = $( 'header[role=banner]' );
		var $navToggle       = $( '#menu-toggle', $header );
		var $navPrimary      = $( '#primary-menu' );
		var $navOverlay      = $( '.nav-overlay' );
		var $parentMenuItems = $( '.menu-item-has-children', $header );
		var $parentMenuHashLinks = $( '> [href="#"]', $parentMenuItems );
		var $searchToggle    = $( '.search-toggle', $header );
		var $searchForm      = $( '.search-form', $header );
		var $searchField     = $( '.search-field', $header );
		var $searchSubmit    = $( '.search-submit', $header );
		var $searchClose,
		    $subMenuToggles;

		// init stuff
		addSubmenuToggles();
		addSearchClose();

		// bind events
		$navToggle.click( toggleMenu );
		$subMenuToggles.click( toggleSubmenu );
		$parentMenuHashLinks.click( toggleSubmenu );
		$navOverlay.click( toggleMenu );
		$searchToggle.click( toggleSearch );
		$searchClose.on( 'click', hideSearch );
		$searchField.on( 'blur', handleSearchFieldBlur );
		$searchSubmit.on( 'blur', handleSearchSubmitBlur );

		/**
		 * Toggler: toggle class and position menu
		 *
		 * @since 1.7.0
		 */
		function toggleMenu() {
			$body.toggleClass( 'nav-toggled' );
			$navPrimary.toggleClass( 'toggled' ); // just for accessibility JS
			$header.toggleClass( 'toggled' );
			$navToggle.toggleClass( 'toggled' );
			$navOverlay.fadeToggle( 400 );

			$navToggle.attr(
				'aria-expanded',
				$navToggle.attr( 'aria-expanded' ) === 'true' ? 'false' : 'true'
			);

			if ( $searchForm.hasClass( 'toggled' ) ) {
				hideSearch();
			}
		}


		/**
		 * Add mobile submenu dropdown toggles, then bind them to toggles var
		 *
		 * @since 1.7.0
		 */
		function addSubmenuToggles() {

			$parentMenuItems.append(
				'<button class="toggle-sub"><span class="screen-reader-text">' + BLUJAY.i18n.toggleSubMenu + '</span><i class="fas fa-angle-down"></i></button>'
			);

			$subMenuToggles = $( '.toggle-sub', $parentMenuItems );
		}


		/**
		 * Toggle mobile submenu
		 *
		 * @since 1.7.0
		 */
		function toggleSubmenu() {

			var $li = $( this ).parent();
			$li.toggleClass( 'sub-toggled' );

			// double-check the scroll-y
			$( '> .sub-menu', $li ).slideToggle( 300 );
		}

		/**
		 * Add the search closing button
		 *
		 * @since 1.7.0
		 */
		function addSearchClose() {
			$searchSubmit.after( '<span class="search-close">' + BLUJAY.i18n.closeSearch + '<i class="fas fa-times"></i></span>' );
			$searchClose = $( '.search-close', $searchForm );
		}

		/**
		 * Show/hide the search
		 *
		 * @since 1.7.0
		 */
		function toggleSearch() {

			if ( $searchForm.hasClass( 'toggled' ) ) {
				hideSearch();
			} else {
				showSearch();
			}
		}

		/**
		 * Show the search
		 *
		 * @since 1.7.0
		 */
		function showSearch() {
			$searchToggle.addClass( 'toggled' );
			$searchForm.addClass( 'toggled' );
			$searchToggle.attr( 'aria-expanded', 'true' );

			$( '[type="search"]', $searchForm ).focus();

			window.addEventListener( 'keydown', handleSearchEsc );
			document.body.addEventListener( 'click', handleSearchClickOut );
		}

		/**
		 * Hide the search
		 *
		 * @since 1.7.0
		 */
		function hideSearch() {
			$searchToggle.removeClass( 'toggled' );
			$searchForm.removeClass( 'toggled' );
			$searchToggle.attr( 'aria-expanded', 'false' );

			window.removeEventListener( 'keydown', handleSearchEsc );
			document.body.removeEventListener( 'click', handleSearchClickOut );
		}

		/**
		 * Handle keypress and toggle search if it's esc
		 *
		 * @param {event}  e  keydown event
		 * @since 1.7.0
		 */
		function handleSearchEsc( e ) {
			if ( e.key == 'Escape' ) {
				hideSearch();
			}
		}

		/**
		 * Handle exiting search by clicking out
		 *
		 * @param {event}  e
		 * @since 1.7.0
		 */
		function handleSearchClickOut( e ) {

			// if we aren't clicking something in header
			if ( ! e.target.closest( '[role="banner"]' ) ) {
				hideSearch();
			}
		}

		/**
		 * Close the search if leaving input to anything other than submit.
		 *
		 * @param {event}  e
		 * @since 1.7.0
		 */
		function handleSearchFieldBlur( e ) {
			if (
				e.relatedTarget &&
				! e.relatedTarget.classList.contains( 'search-toggle' ) &&
				! e.relatedTarget.classList.contains( 'search-submit' )
			) {
				hideSearch();
			}
		}

		/**
		 * Close the search if leaving the submit to anything other than the
		 * field
		 *
		 * @param {event}  e
		 * @since 1.7.0
		 */
		function handleSearchSubmitBlur( e ) {
			if (
				e.relatedTarget &&
				! e.relatedTarget.classList.contains( 'search-field' )
			) {
				hideSearch();
			}
		}

	}); // document.ready
})(jQuery);
